export default __webpack_public_path__ + "static/blob2-71121da49a8486e952206f9bb913584e.svg";